import {
    Breadcrumb,
    Layout,
    Form,
    Input,
    DatePicker,
    Select,
    Button,
    Row,
    Col,
    Card,
    Switch,
    message // Added missing import
} from "antd";
import { APPBACKGROUND_COLOR } from "../appsettings";
import { TSHIRT_SIZES, SHOE_SIZES, TROUSER_SIZES } from "../../constant/constant";
import Headerdiv from "../layout/header";
import { Content } from "antd/es/layout/layout";
import { Link, useNavigate } from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import Footerdiv from "../layout/footer";
import axiosClient from "../../api/axiosClient";

const { Option } = Select;

export const MemberCreate = () => {
    const [form] = Form.useForm();
    const USERID = localStorage.getItem("USERID");
    const navigate = useNavigate();

    const onFinish = async (values) => {
        const payload = {
            ...values,
            birthday: values.birthday ? values.birthday.format("YYYY-MM-DD") : null,
            status: values.status ? true : false,
            by: USERID
        };

        try {
            const response = await axiosClient.post(`/member/add_member.php`, payload);

            const data = response.data;

            if (data.status === "success") {
                message.success(data.message);
                form.resetFields();
                navigate('/members/view');
            } else {
                message.error(data.message || "Failed to add member");
            }
        } catch (error) {
            console.error("API Error:", error);
            message.error(error.response?.data?.message || "Failed to connect to server.");
        }
    };

    return (
        <Layout style={{ backgroundColor: APPBACKGROUND_COLOR }}>
            <Headerdiv />
            <Content style={{ padding: "10px" }}>
                <Breadcrumb style={{ marginBottom: 10 }}>
                    <Breadcrumb.Item>
                        <Link to={"/members/view"}>Members</Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>Create A Member</Breadcrumb.Item>
                </Breadcrumb>

                <Form layout="vertical" form={form} onFinish={onFinish}>
                    <Card title="Member Imformations">
                        <Row gutter={[16, 16]}>

                            <Col xs={24} sm={12} md={4}>
                                <Form.Item
                                    name="member_id"
                                    label="Member ID"
                                    type="number"
                                    rules={[{ required: true, message: "Member ID is required" }]}
                                >
                                    <Input placeholder="Enter Member ID" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={4}>
                                <Form.Item
                                    name="nic"
                                    label="NIC"
                                    rules={[
                                        { required: true, message: "NIC is required" },
                                        {
                                            pattern: /^([0-9]{9}[VvXx]|[0-9]{12})$/,
                                            message: "Enter a valid Sri Lankan NIC",
                                        },
                                    ]}
                                >
                                    <Input placeholder="Enter NIC" />
                                </Form.Item>
                            </Col>

                            <Col xs={24} sm={12} md={8}>
                                <Form.Item
                                    name="name"
                                    label="Full Name"
                                    rules={[{ required: true, message: "Name is required" }]}
                                >
                                    <Input placeholder="Enter Name" />
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={6} md={4}>
                                <Form.Item
                                    name="birthday"
                                    label="Birthday"
                                    rules={[{ required: true, message: "Birthday is required" }]}
                                >
                                    <DatePicker style={{ width: "100%" }} />
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={6} md={4}>
                                <Form.Item
                                    name="gender"
                                    label="Gender"
                                    rules={[{ required: true, message: "Select Gender" }]}
                                >
                                    <Select placeholder="Select Gender">
                                        <Option value="M">Male</Option>
                                        <Option value="F">Female</Option>
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={12} md={4}>
                                <Form.Item
                                    name="contact_no"
                                    label="Contact Number"
                                    rules={[
                                        { required: true, message: "Contact is required" },
                                        {
                                            pattern: /^(?:0\d{9}|\+94\d{9})$/,
                                            message: "Enter a valid Sri Lankan phone number",
                                        },
                                    ]}
                                >
                                    <Input placeholder="Enter Contact Number" />
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={12} md={4}>
                                <Form.Item
                                    name="emergency_contact"
                                    label="Emergency Contact"
                                    rules={[
                                        { required: true, message: "Emergency Contact is required" },
                                        {
                                            pattern: /^(?:0\d{9}|\+94\d{9})$/,
                                            message: "Enter a valid Sri Lankan phone number",
                                        },
                                    ]}
                                >
                                    <Input placeholder="Enter Emergency Contact" />
                                </Form.Item>
                            </Col>

                            <Col xs={16} sm={16} md={16}>
                                <Form.Item
                                    name="address"
                                    label="Address"
                                    rules={[{ required: true, message: "Address is required" }]}
                                >
                                    <Input.TextArea rows={1} placeholder="Enter Address" />
                                </Form.Item>
                            </Col>

                            {/* HEALTH NOTES */}
                            <Col xs={24}>
                                <Form.Item name="health_conditions" label="Health Notes">
                                    <ReactQuill theme="snow" />
                                </Form.Item>
                            </Col>

                            {/* Sizes */}
                            <Col xs={12} sm={6} md={6}>
                                <Form.Item name="tshirt_size" label="T-Shirt Size">
                                    <Select placeholder="Select T-Shirt Size" allowClear>
                                        {TSHIRT_SIZES.map(size => <Option key={size.value} value={size.value}>{size.label}</Option>)}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={6} md={6}>
                                <Form.Item name="shoe_size" label="Shoe Size">
                                    <Select placeholder="Select Shoe Size" allowClear>
                                        {SHOE_SIZES.map(size => <Option key={size.value} value={size.value}>{size.label}</Option>)}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={6} md={6}>
                                <Form.Item name="trouser_size" label="Trouser Size">
                                    <Select placeholder="Select Trouser Size" allowClear>
                                        {TROUSER_SIZES.map(size => <Option key={size.value} value={size.value}>{size.label}</Option>)}
                                    </Select>
                                </Form.Item>
                            </Col>

                            <Col xs={12} sm={6} md={6}>
                                <Form.Item name="status" label="Status">
                                    <Switch defaultChecked />
                                </Form.Item>
                            </Col>

                            {/* --- BUTTONS MOVED HERE --- */}
                            <Col xs={24}>
                                <Row justify="end" gutter={[10, 10]} style={{ marginTop: 10 }}>
                                    <Col>
                                        <Button onClick={() => form.resetFields()}>Clear</Button>
                                    </Col>
                                    <Col>
                                        <Button type="primary" htmlType="submit">
                                            Create Member
                                        </Button>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Card>
                </Form>
            </Content>
            <Footerdiv />
        </Layout>
    );
};